/**
 * FE#312 — time-input validity rules for the "don't auto-correct" fix.
 *
 * The scheduled-message time field used to auto-correct partial/invalid input
 * mid-typing (clamping + reformatting on every keystroke, which snapped a
 * prefilled "14:00" back and jumped the caret when the user tried to type
 * "12:30"). Now the raw typed value is left EXACTLY as typed, and these
 * predicates drive an error state + a disabled submit button until the value is a
 * complete, in-range HH:mm.
 */
import { isCompleteValidTime } from './time-input-utils';

/**
 * Show the error (red) state: the user has typed something, but it isn't yet a
 * complete, in-range HH:mm. An empty field is NOT an error — nothing typed yet.
 */
export const isTimeInErrorState = (raw: string): boolean =>
  (raw ?? '').length > 0 && !isCompleteValidTime(raw ?? '');

/** Block submit for anything that is not a complete, in-range HH:mm (empty included). */
export const shouldBlockSubmitForTime = (raw: string): boolean => !isCompleteValidTime(raw ?? '');
